import { createSelector } from '@reduxjs/toolkit';
import filter from 'lodash/filter';
import find from 'lodash/find';
import get from 'lodash/get';

import { EMPTY_ARRAY, EMPTY_OBJECT } from 'lib/constants';
import { GET_MENU_MEALS_V3_RESPONSE } from 'lib/constants/v3Actions';

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_MENU_MEALS_V3_RESPONSE:
      return {
        ...state,
        [action.params.menuSlug]: action.response.mealOptionGroups,
      };

    default:
      return state;
  }
};

// Selector Logic
const getGroupsState = state => state || EMPTY_OBJECT;
const getMenuSlug = (state, menuSlug) => menuSlug;
const getMealId = (state, menuSlug, mealId) => mealId;
const getGroupId = (state, menuSlug, mealId, groupId) => groupId;

export const selectMealOptionGroupsForMenu = createSelector(
  [getGroupsState, getMenuSlug],
  (groupsState, menuSlug) => get(groupsState, menuSlug, EMPTY_ARRAY)
);

export const selectMealOptionGroupsForMenuAndMeal = createSelector(
  [selectMealOptionGroupsForMenu, getMealId],
  (menuGroups, mealId) => {
    const result = filter(menuGroups, { mealId });

    if (result.length < 1) return EMPTY_ARRAY;

    return result;
  }
);

export const selectMealOptionGroup = createSelector(
  [selectMealOptionGroupsForMenuAndMeal, getGroupId],
  (mealGroups, groupId) => find(mealGroups, { id: groupId }) || EMPTY_OBJECT
);
